import { HStack, Highlight, Text, VStack } from '@chakra-ui/react';
import React from 'react';

const styleListItem = (isSelected: boolean) => ({
  bg: isSelected ? 'bg.light' : 'transparent',
  px: 'md',
  py: 1,
  borderColor: 'border.pure',
  spacing: 'sm',
  w: 'full',
});

export interface AutocompleteOption {
  label: string;
  value: any;
  description?: string;
}

interface DefaultOptionProps {
  inputValue: string;
  isSelected: boolean;
  option: AutocompleteOption;
}

const DefaultOption: React.FC<DefaultOptionProps> = ({ isSelected, inputValue, option }) => (
  <HStack
    {...styleListItem(isSelected)}
    _hover={{ cursor: 'pointer' }}
  >
    <VStack
      alignItems='start'
      justify='center'
      minH={10}
      spacing={0}
    >
      <Text as='span'>
        <Highlight
          query={inputValue}
          styles={{ fontWeight: 'bold' }}
        >
          {option?.label || String(option)}
        </Highlight>
      </Text>
      {option.description && (
        <Text
          as='span'
          color='typography.secondary'
          fontSize='sm'
        >
          {option.description}
        </Text>
      )}
    </VStack>
  </HStack>
);

export default DefaultOption;
